<template>
<section class="guarantee-info">
  <div class="definitions-list">
    <definition v-for="definition in definitions"
                :key="definition.key"
                :title="definition.title"
    >
      <div v-html="definition.content"></div>
    </definition>
  </div>
</section>
</template>

<script>
import { mapGetters } from 'vuex'
import Definition from '@/components/lists/Definition'
import HasDefinitions from '@/mixins/HasDefinitions'

export default {
  components: {
    Definition,
  },
  mixins: [
    HasDefinitions,
  ],

  computed: {
    ...mapGetters({
      settings: 'settings/deliveryPaymentsGuarantee',
    }),
  },
}
</script>
